<template>
  <div class="basket container">
    <div class="row basket-header">
      <div class="col-12">Koszyk</div>
    </div>
    <div v-for="b in basket.baskets" class="basket-group">
      <div class="row basket-header-address">
        <div class="col-12">
          Adres dostawy:
          <div
            v-if="b.address"
            class="basket-group-delivery"
          >{{ b.address.city }}, {{ b.address.street }}</div>
        </div>
      </div>
      <div class="row basket-header-cols">
        <div>zdjęcie</div>
        <div v-if="mpkEnable">nazwa</div>
        <div v-else>nazwa</div>
        <div>komentarz</div>
        <div>adres dostawy</div>
        <div v-if="mpkEnable">MPK</div>
        <div class="basket-quantity-header">ilość</div>
        <div class>cena netto</div>
        <div class>VAT</div>
        <div class>cena brutto</div>
        <div class>akcje</div>
      </div>

      <div v-for="position in b.positions" class="row basket-position">
        <div class="basket-mobile-names">zdjęcie</div>
        <div class="basket-photo">
          <img :src="position.photo_url" class="img-fluid" />
        </div>

        <div class="basket-mobile-names">nazwa</div>
        <div v-if="mpkEnable" class="col-lg-2 basket-name">
          <router-link :to="{ name: 'productPage', params:{id: position.product_id, slug: 'item'}}">
            <span>{{position.name}}</span>
          </router-link>
        </div>
        <div v-else class="basket-name">
          <router-link :to="{ name: 'productPage', params:{id: position.product_id, slug: 'item'}}">
            <span>{{position.name}}</span>
          </router-link>
        </div>

        <div class="basket-mobile-names">komentarz</div>
        <div class="basket-description">
          <textarea
            cols="20"
            rows="3"
            v-model="position.description"
            @change="modify(position)"
            class="form-control"
          ></textarea>
        </div>

        <div class="basket-mobile-names">adres dostawy</div>
        <div class="basket-address">
          <!-- <select v-model="position.address_id" @change="modify(position)" class="form-control"> -->
          <select v-model="position.address_id" @change="modify(position)" class="form-control">
            <option
              v-for="address in user.addresses"
              :value="address.id"
            >{{ address.city }}, {{ address.street }}</option>
          </select>
        </div>

        <div class="basket-mobile-names">mpk</div>
        <div v-if="mpkEnable" class="basket-mpk">
          <select v-model="position.mpk_id" @change="modify(position)" class="form-control">
            <option v-for="mpk in company.mpks" :value="mpk.mpk.id">{{mpk.mpk.name}}</option>
          </select>
        </div>

        <div class="basket-mobile-names">ilość</div>
        <div class="basket-quantity">
          <div class="input-group quantity-input">
            <!--
            <div class="input-group-prepend" @click="subQuantity(position)">
              <span class="input-group-text" id="basic-addon1"><minus-icon></minus-icon></span>
            </div>
            -->
            <input
              type="text"
              class="form-control"
              :value="position.cart_quantity"
              @keyup="verifyQuantity($event, position)"
            />
            <span class="unit-name">{{position.unit_name}}</span>

            <!--
            <div class="input-group-append" @click="addQuantity(position)">
              <span class="input-group-text"><plus-icon></plus-icon></span>
            </div>
            -->
          </div>
        </div>

        <div class="col basket-mobile-names">cena netto</div>
        <div
          class="basket-net price"
        >{{priceToString(position.price_net * position.cart_quantity, currency().currency.symbol)}}</div>
        <div class="basket-mobile-names">VAT</div>
        <div
          class="basket-tax price"
        >{{priceToString(position.price_tax * position.cart_quantity, currency().currency.symbol)}}</div>
        <div class="basket-mobile-names">brutto</div>
        <div
          class="basket-gross price"
        >{{priceToString(position.price_gross * position.cart_quantity, currency().currency.symbol)}}</div>
        <div class="basket-mobile-names">akcje</div>
        <delete-icon class="basket-action" title="Usuń" @click.native="remove(position)" />
        <!-- GRATIS start -->
        <div v-if="position.range" class="basket-gratis-info my-1">
          <div
            v-if="position.cart_quantity < position.range.min_quantity"
            class="alert alert-info mb-0"
          >
            <img
              src="./../../../assets/icons/info.svg"
              alt="Info Icon"
              class="basket-gratis-info-icon mr-1"
              style="width: 1.5rem;"
            />
            Kup jeszcze {{quantityToGratis(position.range.min_quantity, position.cart_quantity)}}
            <!-- <span>{{quantityToGratisLabel(position.range.min_quantity, position.cart_quantity)}}</span> -->
            <span
              v-if="quantityToGratis(position.range.min_quantity, position.cart_quantity) === 1"
            >sztukę</span>
            <span
              v-else-if="quantityToGratis(position.range.min_quantity, position.cart_quantity) >= 2 && quantityToGratis(position.range.min_quantity, position.cart_quantity) <= 4"
            >sztuki</span>
            <span v-else>sztuk</span>
            tego produktu, a otrzymasz
            <span
              class="basket-gratis-product"
            >{{ position.range.product_name }}</span>
          </div>
          <div v-else class="alert alert-success mb-0">
            <img
              src="./../../../assets/icons/info.svg"
              alt="Info Icon"
              class="basket-gratis-info-icon mr-1"
              style="width: 1.5rem;"
            />
            Otrzymujesz gratis
            <span
              class="basket-gratis-product"
            >{{ position.range.product_name }}!</span>
          </div>
        </div>
        <!-- GRATIS end -->
      </div>

      <div class="row basket-footer">
        <div class="total-price-label">Razem:</div>
        <div
          class="total-price-value total-net text-success"
        >{{priceToString(b.price_net, currency().currency.symbol)}}</div>
        <div
          class="total-price-value total-tax text-success"
        >{{priceToString(b.price_tax, currency().currency.symbol)}}</div>
        <div
          class="total-price-value total-gross text-success"
        >{{priceToString(b.price_gross, currency().currency.symbol)}}</div>
      </div>
    </div>

    <div v-if="basket.mpk_summary_list.length > 0 && clientLimit >0" class="basket-group">
      <div class="col-12">Limity konsumencki</div>
      <div class="row">
        <div class="col-10 total right">Limit</div>
        <div class="col-2 price">{{priceToString(clientLimit, currency().currency.symbol)}}</div>
      </div>

      <div v-if="basket.mpk_summary_list.length > 0" class="col-12">Limity budżetów</div>
      <div
        v-if="basket.mpk_summary_list.length > 0"
        v-for="mpk in basket.mpk_summary_list"
        class="row mpk-summary"
      >
        <div class="col-10 total right">{{mpk.name}}</div>
        <div class="col-2 price">{{priceToString(mpk.limit, currency().currency.symbol)}}</div>
      </div>
    </div>

    <div class="row order-header">
      <div class="col-12">
        <button
          type="button"
          class="btn btn-success pull-right"
          @click="orderForm"
        >Przejdź do zamówienia</button>
      </div>
    </div>
  </div>
</template>


<script>
import DeleteIcon from "vue-material-design-icons/Delete.vue";
import SubIcon from "vue-material-design-icons/Minus.vue";
import PlusIcon from "vue-material-design-icons/Plus.vue";
import { mapState, mapGetters } from "vuex";
import MinusIcon from "vue-material-design-icons/Minus.vue";
import CalculatePrice from "../../products/src/product/CalculatePrice";

export default {
  components: {
    MinusIcon,
    PlusIcon,
    DeleteIcon,
  },

  computed: {
    ...mapState({
      basket: (state) => state.basket.basket,
      user: (state) => state.user,
      company: (state) => state.company,
      mpkEnable: (state) =>
        state.shop.settings.find((s) => s.name == "B2B_MPK_ENABLED")
          ? state.shop.settings.find((s) => s.name == "B2B_MPK_ENABLED")
          : 0,
      shop: (state) => state.shop.settings,
      demo: (state) => state.demo.enabled,
    }),
    ...mapGetters({
      currency: "company/selectedCurrency",
      clientLimit: "company/clientLimit",
    }),
  },
  data() {
    return {
      units: { single: [], decimals: [] },
      purchaseOverbookedProducts: false,
    };
  },
  methods: {
    ...CalculatePrice(),

    quantityToGratis(range, basket) {
      return range - basket;
    },

    subQuantity(position) {
      if (position.cart_quantity > 0) {
        if (this.units.single.indexOf(position.unit_name) >= 0) {
          position.cart_quantity--;
        } else if (this.units.decimals.indexOf(position.unit_name) >= 0) {
          position.cart_quantity =
            Math.round((position.cart_quantity - 0.001) * 1000) / 1000;
        } else {
          position.cart_quantity--;
        }
        this.modify(position);
      }
    },

    addQuantity(position) {
      if (position.cart_quantity < position.quantity) {
        if (this.units.single.indexOf(position.unit_name) >= 0) {
          position.cart_quantity++;
        } else if (this.units.decimals.indexOf(position.unit_name) >= 0) {
          position.cart_quantity =
            Math.round((position.cart_quantity + 0.001) * 1000) / 1000;
        } else {
          position.cart_quantity++;
        }
        this.modify(position);
      }
    },

    verifyQuantity(ev, position) {
      let keyValue = ev.target.value;
      setTimeout(() => {
        if (keyValue == ev.target.value) {
          let val = parseFloat(keyValue.replace(",", "."));
          val = val > 0 ? parseFloat(ev.target.value.replace(",", ".")) : 1;
          if (this.units.single.indexOf(position.unit_name)) {
            val = Math.ceil(val);
          }
          if (val > position.quantity && !this.purchaseOverbookedProducts) {
            val = position.quantity;
          }
          position.cart_quantity = val;
          this.modify(position);
        }
      }, 1500);
    },

    remove(position) {
      this.$store.dispatch("basket/removePosition", position);
    },

    modify(position) {
      this.$store.dispatch("basket/modifyPosition", position);
    },

    orderForm() {
      this.$router.replace({ name: "orderForm" });
    },
  },

  beforeMount() {
    if (!this.$store.state.user.authorizedUser) {
      this.$router.replace({ name: "mainPage" });
    }
    if (!this.demo) {
      this.units = this.$config.get("basket.units");
      this.$store.dispatch("user/getAddresses");
      this.$store.dispatch("basket/data");
      this.$store.dispatch("company/mpks");
      let b2bOverbooking = this.shop.find((s) => s.name == "B2B_OVERBOOKING");
      this.purchaseOverbookedProducts =
        b2bOverbooking && b2bOverbooking.value == 1;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/basket/src/Basket.vue